import baseAPI from '@/api/base';
import {
  EditMinyanim,
  GetMinyanim,
  RegisterMinyanim,
} from '@/dtos/minyanim.dto';
import {
  DELETE_MINYANIM_URL,
  EDIT_MINYANIM_URL,
  GET_MINYANIM_URL,
  REGISTER_MINYANIM_URL,
  SYNC_MINYANIM_URL,
  TOGGLE_MINYANIM_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Minyanim {
  static getMinyanims = async (
    getMinyanim: GetMinyanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MINYANIM_URL, {
      params: getMinyanim,
    });
    console.log('response', response);
    return response;
  };

  static registerMinyanim = async (
    registerMinyanim: RegisterMinyanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MINYANIM_URL,
      {
        ...registerMinyanim,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMinyanim = async (
    editMinyanim: EditMinyanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MINYANIM_URL,
      {
        ...editMinyanim,
      }
    );
    return response;
  };

  static syncMinyanim = async (
    editMinyanim: EditMinyanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      SYNC_MINYANIM_URL,
      {
        ...editMinyanim,
      }
    );
    return response;
  };

  static toggleMinyanimIsActive = async (
    editMinyanim: EditMinyanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MINYANIM_IS_ACTIVE_URL,
      {
        ...editMinyanim,
      }
    );
    return response;
  };

  static deleteMinyanim = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MINYANIM_URL}/${id}`
    );
    return response;
  };
}

export default Minyanim;
